module.exports = "https://cdn.hellotech.com/client-assets/lock_wide_f9afc4991e51958c431204139c301bb2.jpg";